import cx from "classnames";

import styles from "./PillBadgeBordered.module.scss";

const PillBadgeBordered = ({
  textContent,
  className = "",
  handleClick,
  isSelected = false,
}) => {
  return (
    <button
      onClick={handleClick}
      className={cx(
        className,
        styles.PillBadgeBordered,
        isSelected ? styles.PillBadgeBorderedSelected : null,
      )}>
      {textContent}
    </button>
  );
};

export default PillBadgeBordered;
